export default __webpack_public_path__ + "assets/img/ic-confirm-change.1dea1c9ba197316e5d005d1ab18d48e9.svg";